import type { IconData } from '@stacksjs/iconify-core'

export const ballSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M21.496 1.637a22.4 22.4 0 0 0-12.31 5.427l7.622 7.623a19.42 19.42 0 0 0 4.688-13.05m-2.561 15.177a22.4 22.4 0 0 0 5.56-15.31a22.4 22.4 0 0 1 14.319 5.56L24 21.878zm-4.248-.006a19.42 19.42 0 0 1-13.05 4.688a22.4 22.4 0 0 1 5.427-12.31zm2.127 2.127L21.878 24L7.064 38.814a22.4 22.4 0 0 1-5.56-14.32q.247.006.496.006c5.673 0 10.856-2.1 14.814-5.565m24.121-9.75a22.4 22.4 0 0 1 5.56 14.32Q46.246 23.5 46 23.5a22.42 22.42 0 0 0-14.815 5.564L26.121 24zM24 26.12l5.064 5.065a22.4 22.4 0 0 0-5.56 15.31a22.4 22.4 0 0 1-14.319-5.56zm14.814 14.815l-7.623-7.623a19.42 19.42 0 0 0-4.688 13.05a22.4 22.4 0 0 0 12.31-5.427m-5.501-9.745l7.623 7.624a22.4 22.4 0 0 0 5.427-12.311q-.18-.003-.363-.003a19.42 19.42 0 0 0-12.687 4.69\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default ballSolid
